export class SaleSendCloudParcel {
	ID:number = 0;
	BookYear:number = 0;
	SaleID:number = 0;
	ParcelID:number = 0;

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.BookYear = data.BookYear;
		this.SaleID = data.SaleID;
		this.ParcelID = data.ParcelID;
	}

	public openInSendcloud(){
		window.open(`https://app.sendcloud.com/v2/shipping/${this.ParcelID}/details`);
	}
}